import { IPackageListingAppBaseText, defaultBaseText } from "../../classes/package-listing-text";

/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
interface IPackageListingCustomText {
    accessibleSeatingLabel: string;
    accessibleSeatingText: string;
    productionInCartMessage: string;
    showPerformancesText: string;
    hidePerformancesText: string;
    facilityFilterLabelText: string;
    facilityFilterDefaultValue: string;
    venueOverride: string;
    hideVenues: boolean;
    hideProductionFilter: boolean;
}


let customText: IPackageListingCustomText = {
    accessibleSeatingLabel: "",
    accessibleSeatingText: "",
    productionInCartMessage: "",
    hidePerformancesText: "",
    showPerformancesText: "",
    facilityFilterDefaultValue: "",
    facilityFilterLabelText: "",
    venueOverride: "",
    hideVenues: false,
    hideProductionFilter: false
}

export type IPackageListingAppText = IPackageListingCustomText & IPackageListingAppBaseText;
export const defaultText: IPackageListingAppText = { ...defaultBaseText, ...customText };